<template>
  <div class="timer-component is-mobile" id="timer-component">
    <div v-if="true || isMobile || displayGreenTimer" class="mobile" :class="{ 'black-friday': showBlackFriday, christmas: showChristmas }">
      <span v-html="titleText"></span> <span>{{ time }}</span>
    </div>
    <!-- <div v-else class="desktop">
      <span v-html="titleText"></span>
      <div class="d-flex" dir="ltr">
        <div class="timer-component__minutes">
          <div><div class="line"></div>{{time[0]}}</div>
          <div><div class="line"></div>{{time[1]}}</div>
        </div>
        <div class="timer-component__dots">
          <span></span>
          <span></span>
        </div>
        <div class="timer-component__seconds">
          <div><div class="line"></div>{{time[3]}}</div>
          <div><div class="line"></div>{{time[4]}}</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import isMobile from "../../mixins/isMobile";
import queryToComponent from "../../mixins/queryToComponent";

let interval = null;
let startSeconds = 0;

export default {
  name: "Timer",
  mixins: [isMobile, queryToComponent],

  props: {
    startMinutes: {
      default: 13
    },
    title: {
      default: null
    }
  },

  data() {
    return {
      time: ("0" + this.startMinutes).slice(-2) + ":" + ("0" + startSeconds).slice(-2),
      displayGreenTimer: false
    };
  },

  computed: {
    titleText() {
      if (this.time === "00:00") {
        return this.$t("checkout.timer.time_over");
      }

      if (this.title) {
        return this.title;
      }

      if (this.showBlackFriday) {
        return this.$t("checkout.black_friday_sepcial") + " - " + this.$t("checkout.timer.valid_for");
      } else if (this.showChristmas) {
        return this.$t("checkout.christmas_sepcial") + " - " + this.$t("checkout.timer.valid_for");
      } else {
        return this.$t("checkout.timer.valid_for");
      }
    },
    showBlackFriday() {
      return this.queryParams.holiday == 1 && js_data.is_black_friday;
    },
    showChristmas() {
      return this.queryParams.holiday == 1 && js_data.is_christmas;
    },
    finishTime() {
      return new Date(new Date().getTime() + this.startMinutes * 60 * 1000 + (startSeconds + 1) * 1000);
    }
  },

  methods: {
    changeTimeByDifference() {
      let diff = this.finishTime.getTime() - new Date().getTime();
      diff = Math.floor(diff / 1000);

      const minutes = Math.floor(diff / 60) % 60;
      const seconds = diff % 60;

      this.time = [minutes, seconds].map(numbers => ("0" + numbers).slice(-2)).join(":");

      if (this.time === "00:00") {
        clearInterval(interval);
      }
    },

    isVmpPage() {
      if (this.queryParams.tpl && this.queryParams.tpl.indexOf("vmp") >= 0) {
        this.displayGreenTimer = true;
      }
    }
  },

  mounted() {
    interval = setInterval(this.changeTimeByDifference, 1000);
    this.isVmpPage();
  }
};
</script>

<style lang="scss">
@import "../../../sass/variables";

// .fixed-region #timer-component.is-desktop {
//   display: none;
// }

// #header #timer-component.is-mobile {
//   display: none;
// }

.timer-component {
  flex-grow: 1;
  position: absolute;
  width: 100%;
  top: 0;
  right: 0;
  left: 0;

  &.is-mobile {
    position: relative;
    top: unset;
    right: unset;
    left: unset;
  }

  &.header-timer {
    .black-friday {
      background-color: #333333;
      b {
        color: red;
        text-decoration: underline;
      }
    }
    .christmas {
      background-color: #e74c3c;
      b {
        color: #fef036;
        text-decoration: underline;
      }
    }
  }

  .mobile {
    padding: 15px 40px;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    background-color: #22ab9f;

    @media screen and ($s-down) {
      font-size: 16px;
      padding: 10px 40px;
    }

    & > span {
      margin-left: 5px;
    }
  }

  //  We dont use flipdown digits view anymore
  // @media screen and ($s-up) {
  //   position: relative;
  //   order: 1;

  //   & > .desktop {
  //     display: flex;
  //     justify-content: flex-end;
  //     height: 100%;
  //     align-items: center;
  //     font-family: "Open Sans", sans-serif;

  //     & > * {
  //       padding: 7px 0;
  //     }

  //     & > span {
  //       font-weight: 700;
  //       font-size: 20px;
  //       text-align: center;
  //       width: 50%;
  //     }

  //     .timer-component__minutes, .timer-component__seconds {
  //       display: flex;

  //       & > div {
  //         padding: 0px 2px;
  //         font-weight: 700;
  //         color: #ccc;
  //         text-shadow: 0 1px 2px #000;
  //         text-align: center;
  //         background-color: #333;
  //         border-radius: 6px;
  //         font-size: 54px;
  //         margin-right: 5px;
  //         position: relative;

  //         .line {
  //           position: absolute;
  //           width: 100%;
  //           height: 1px;
  //           background-color: #000;
  //           left: 0;
  //           top: 50%;
  //           transform: translateY(-50%);
  //         }
  //       }
  //     }

  //     .timer-component__dots {
  //       display: flex;
  //       flex-direction: column;
  //       justify-content: space-between;
  //       margin-right: 5px;
  //       padding: 18px 0;
  //       height: auto;

  //       span {
  //         display: block;
  //         background: #323434;
  //         width: 7px;
  //         height: 7px;
  //         border-radius: 50%;
  //         box-shadow: 0 0 5px rgba(0,0,0,0.5);
  //       }
  //     }
  //   }
  // }
}
</style>
